import { useCanvasStore } from "@/stores/canvas-store";
import { useTTS } from "@/desktop/use-tts";

/** Apply the same exact-question cleanup after HTTP as after its WS receipt. */
export function resolveCursorQuestion(awaitingInputId: string) {
  const canvas = useCanvasStore.getState();
  canvas.removeAwaitingInput(awaitingInputId);
  for (const [agentId, cursor] of canvas.agentCursors) {
    if (cursor.question?.awaitingInputId === awaitingInputId)
      canvas.clearAgentCursorQuestion(agentId);
  }
  useTTS
    .getState()
    .cancelPresentationSpeech(`awaiting-input:${awaitingInputId}`);
}
